import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: all 0.3s;\n  min-height: 62px;\n  border-radius: 6px;\n  cursor: pointer;\n\n  .related-product-price,\n  .desc {\n    color: ",
        ";\n    line-height: 1.5;\n    letter-spacing: -0.16px;\n  }\n\n  .related-product-price {\n    font-size: 16px;\n    margin-right: 20px;\n    font-weight: normal;\n    flex-shrink: 0;\n  }\n\n  .title {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: 16px;\n    line-height: 1.5;\n    letter-spacing: -0.16px;\n  }\n\n  &.selected {\n    background-color: ",
        ";\n\n    .mask {\n      display: block;\n    }\n  }\n\n  :hover {\n    background-color: ",
        ";\n\n    .mask {\n      display: block;\n    }\n  }\n\n  @media (max-width: 768px) {\n    min-height: unset;\n    padding: 12px 16px;\n    border-radius: 0;\n    .related-product-price {\n      font-size: 14px;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  margin-right: 16px;\n  cursor: pointer;\n  position: relative;\n  //box-shadow: 3px 3px 12px 0px rgba(28, 31, 46, 0.06);\n  height: 62px;\n  display: flex;\n  align-items: center;\n\n  .mask {\n    top: 0;\n    display: none;\n    position: absolute;\n  }\n\n  img {\n    box-shadow: 3px 3px 12px 0px rgba(28, 31, 46, 0.06);\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  width: 100%;\n  justify-content: space-between;\n  @media (max-width: 768px) {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  border-radius: 2px;\n  max-width: unset;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "@/components/common/Image";
import Icon from "@/components/icon/Icon";
import { ImageMask } from "@/components/icon/IconList";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { Checkbox } from "@bookips/solvook-ui-library";
import { Box, styled as muiStyled } from "@mui/material";
import React, { useCallback, useMemo } from "react";
import styled from "styled-components";
import useHandoutProductStore from "../../../../store/relatedProduct";
import { getDownloadFileName } from "../utils/getDownloadFileName";
export const thumbWidth = 44;
const getOptionText = (product, option)=>{
    if (option === "view") {
        return "열람+출력 (대여)";
    }
    if (option === "download") {
        const { isOriginSellable , originalFileName  } = product;
        return "".concat(getDownloadFileName(isOriginSellable, originalFileName), " 다운 (소장)");
    }
    return "PDF 다운 (소장)";
};
export const RelatedListItem = (param)=>{
    let { product , isFreepass  } = param;
    var _product_purchaseOptions, _product_purchaseOptions1;
    const { toggleSelected , selectedRelatedProducts , openRelatedProductPreviewModal , selectedPurchaseOption , purchaseOption  } = useHandoutProductStore((state)=>({
            toggleSelected: state.toggleRelatedProductSelected,
            selectedRelatedProducts: state.purchaseProductsInfo.selectedRelatedProducts,
            relatedProducts: state.relatedProducts,
            openRelatedProductPreviewModal: state.openRelatedProductPreviewModal,
            selectedPurchaseOption: state.selectedPurchaseOption,
            purchaseOption: state.purchaseOption
        }));
    const isChecked = useMemo(()=>!!selectedRelatedProducts.find((item)=>item.id === product.id), [
        selectedRelatedProducts
    ]);
    const onChange = useCallback(()=>{
        toggleSelected(product);
    }, [
        product
    ]);
    const onClickPreview = useCallback((event)=>{
        event.preventDefault();
        openRelatedProductPreviewModal(product);
        mixpanelEvent("Preview Button Clicked", {
            Proposition: "상품상세페이지",
            bookId: product.title,
            bookTitle: product.title
        });
    }, [
        product
    ]);
    var _product_purchaseOptions_includes;
    const isAvailableView = (_product_purchaseOptions_includes = (_product_purchaseOptions = product.purchaseOptions) === null || _product_purchaseOptions === void 0 ? void 0 : _product_purchaseOptions.includes("view")) !== null && _product_purchaseOptions_includes !== void 0 ? _product_purchaseOptions_includes : false;
    var _product_purchaseOptions_includes1;
    const isAvailableDownload = (_product_purchaseOptions_includes1 = (_product_purchaseOptions1 = product.purchaseOptions) === null || _product_purchaseOptions1 === void 0 ? void 0 : _product_purchaseOptions1.includes("download")) !== null && _product_purchaseOptions_includes1 !== void 0 ? _product_purchaseOptions_includes1 : false;
    let status = "default";
    if (product.hasAlreadyOwned) {
        status = "disabled";
    } else if (selectedPurchaseOption === "view" && isAvailableView) {
        status = "default";
    } else if (selectedPurchaseOption === "download" && isAvailableDownload) {
        status = "default";
    } else {
        status = "disabled";
    }
    const price = product.purchaseOptions.includes(selectedPurchaseOption) ? selectedPurchaseOption === "view" ? product.price : product.downloadPrice : null;
    return /*#__PURE__*/ _jsx(RowLabel, {
        htmlFor: "related-".concat(product.id),
        status: status,
        children: /*#__PURE__*/ _jsxs(RelatedListItemWrapper, {
            className: isChecked ? "selected" : "",
            children: [
                /*#__PURE__*/ _jsxs(ImageContainer, {
                    className: "image-container",
                    onClick: onClickPreview,
                    children: [
                        /*#__PURE__*/ _jsx(ThumbnailImage, {
                            alt: "book-img",
                            width: thumbWidth,
                            height: 62,
                            src: product.thumbImg
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "mask",
                            children: /*#__PURE__*/ _jsx(Icon, {
                                icon: ImageMask
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(Stack, {
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: "title",
                            children: product.title
                        }),
                        (product === null || product === void 0 ? void 0 : product.hasAlreadyOwned) ? /*#__PURE__*/ _jsx("p", {
                            className: "desc",
                            children: "이미 구매한 자료"
                        }) : !isFreepass && /*#__PURE__*/ _jsx("p", {
                            className: "related-product-price",
                            children: "".concat(getOptionText(product, selectedPurchaseOption), " ").concat(price ? price.toLocaleString() + "원" : " 미제공")
                        })
                    ]
                }),
                !product.hasAlreadyOwned && /*#__PURE__*/ _jsx(Box, {
                    sx: {
                        label: {
                            margin: 0
                        }
                    },
                    children: /*#__PURE__*/ _jsx(Checkbox, {
                        id: "related-".concat(product.id),
                        color: "primary",
                        onChange: onChange,
                        checked: isChecked,
                        disabled: status === "disabled"
                    })
                })
            ]
        })
    });
};
const RowLabel = muiStyled("label")((param)=>{
    let { theme , status  } = param;
    return {
        position: "relative",
        "& > div:before": status === "disabled" && {
            content: '""',
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: status === "disabled" ? "rgba(255, 255, 255, 0.60)" : "none",
            position: "absolute",
            left: 0,
            top: 0,
            cursor: "not-allowed",
            zIndex: 1
        },
        "& > div": status === "disabled" && {
            i: {
                display: "none"
            },
            ":hover": {
                backgroundColor: "transparent"
            }
        }
    };
});
const RelatedListItemWrapper = styled.div.withConfig({
    componentId: "sc-d2e2b331-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_gray_500, (props)=>props.theme.new.colors.sol_gray_50, (props)=>props.theme.new.colors.sol_gray_0);
const ImageContainer = styled.div.withConfig({
    componentId: "sc-d2e2b331-1"
})(_templateObject1());
const Stack = styled.div.withConfig({
    componentId: "sc-d2e2b331-2"
})(_templateObject2());
export const ThumbnailImage = styled(Image).withConfig({
    componentId: "sc-d2e2b331-3"
})(_templateObject3());
